/**
 * PRODUCT CARD SWATCH SWAP — TAFT 2026 PLP redesign
 *
 * Clicking a color swatch on a product card swaps the card in place to that
 * color's product (images, links, color label, active swatch) instead of
 * navigating to its PDP. The PDP is still reachable through the card image
 * and title, which are re-pointed to the selected color's URL.
 *
 * Swatch data comes from data-* attributes rendered by product-card-swatches.liquid.
 * Class sets below mirror the ones used in product-card-swatches.liquid and
 * product-card-figure.liquid — keep them in sync if those snippets change.
 */
(() => {
  const ACTIVE_SWATCH_CLASSES = ['w-[24.5px]', 'h-[24.5px]', 'border-[1.5px]', 'border-[#111111]'];
  const INACTIVE_SWATCH_CLASSES = ['w-[18.68px]', 'h-[18.68px]'];
  const SECONDARY_LIFESTYLE_CLASSES = ['object-cover', 'object-center'];
  const SECONDARY_STUDIO_CLASSES = ['object-contain', '[object-position:center_86%]', 'mix-blend-darken'];

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;

    const card = swatch.closest('product-card');
    if (!card) return;

    event.preventDefault();

    const primary = card.querySelector('.product-card__image--primary');
    if (primary && swatch.dataset.image) {
      primary.src = swatch.dataset.image;
      if (swatch.dataset.imageSrcset) {
        primary.setAttribute('srcset', swatch.dataset.imageSrcset);
      } else {
        primary.removeAttribute('srcset');
      }
    }

    let secondary = card.querySelector('.product-card__image--secondary');
    if (swatch.dataset.secondary) {
      if (!secondary && primary) {
        secondary = document.createElement('img');
        secondary.className = 'product-card__image product-card__image--secondary w-full h-full';
        secondary.alt = '';
        primary.insertAdjacentElement('afterend', secondary);
      }
      if (secondary) {
        secondary.src = swatch.dataset.secondary;
        if (swatch.dataset.secondarySrcset) {
          secondary.setAttribute('srcset', swatch.dataset.secondarySrcset);
        } else {
          secondary.removeAttribute('srcset');
        }
        secondary.classList.remove(...SECONDARY_LIFESTYLE_CLASSES, ...SECONDARY_STUDIO_CLASSES);
        if (swatch.dataset.secondaryLifestyle === 'true') {
          secondary.classList.add(...SECONDARY_LIFESTYLE_CLASSES);
        } else {
          secondary.classList.add(...SECONDARY_STUDIO_CLASSES);
        }
        secondary.style.display = '';
      }
    } else if (secondary) {
      secondary.style.display = 'none';
    }

    if (swatch.dataset.productUrl) {
      card.querySelectorAll('.product-card__figure a, a.product-title').forEach((link) => {
        link.href = swatch.dataset.productUrl;
      });
    }
    if (swatch.dataset.productHandle) {
      card.setAttribute('handle', swatch.dataset.productHandle);
    }

    const colorLabel = card.querySelector('[data-variant-color]');
    if (colorLabel && swatch.dataset.colorLabel) {
      colorLabel.textContent = swatch.dataset.colorLabel;
    }

    card.querySelectorAll('[data-card-swatch]').forEach((el) => {
      const isActive = el === swatch;
      el.classList.remove(...ACTIVE_SWATCH_CLASSES, ...INACTIVE_SWATCH_CLASSES);
      el.classList.add(...(isActive ? ACTIVE_SWATCH_CLASSES : INACTIVE_SWATCH_CLASSES));
      if (isActive) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  });
})();
